<template>
  <div :style="`width:${dispW}px;height:${dispH}px;margin:0 auto`">
    <div style="width: 100%; position: relative; left: -13px">
      <h1 class="manualtitle">{{ title }}</h1>
    </div>
    <div class="wrapper-full" ref="trend"></div>
  </div>
</template>
<script>
const timeSeries = [];
for (let i = 0; i < 101; i++) {
  const time = i / 10; // 每个数据点递增 0.1 秒
  timeSeries.push(time.toFixed(1)); // 保留一位小数，格式化为字符串
}
// for (let i = 0; i < 26; i++) {
//   timeSeries.push((i * 0.4).toFixed(1));
// }
// for (var i = 0; i <= 10; i++) {
//   timeSeries.push(i);
// }
import { Size } from "../../mixins";
export default {
  name: "PupilTrendChart",
  data() {
    return {};
  },
  mixins: [Size],
  props: {
    trendData: {
      type: Array,
      default: () => []
    },
    yName: {
      type: String,
      default: "Φ/mm"
    },
    id: {
      type: String,
      default: ""
    },
    xName: {
      type: String,
      default: "(s)"
    },
    xFormater: {
      type: String | Function
    },
    xRange: {
      type: Object,
      default: () => {
        return {
          min: 0,
          max: 21,
          interval: undefined
        };
      }
    },
    title: {
      type: String,
      default: ""
    },
    yRange: {
      type: Object,
      default: () => {
        return {
          min: undefined,
          max: undefined
        };
      }
    },
    gridRight: {
      type: Number,
      default: 0
    },
    titleVisible: {
      type: Boolean,
      default: true
    },
    tearHeightxAxisData: {
      type: Array,
      default: null
    }
  },
  methods: {
    dryTrend() {
      let seriesData = this.trendData;

      let option = {
        // animation: false,
        title: {
          left: "center",
          text: this.title,
          textStyle: {
            color: "#fff",
            fontSize: 20,
            fontFamily: "Microsoft YaHei"
          },
          show: this.titleVisible
        },
        grid: {
          top: 50,
          left: 44,
          right: this.gridRight,
          bottom: 40
        },
        xAxis: {
          name: this.xName,
          // type: 'time',
          nameTextStyle: {
            fontSize: 16
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1
            }
          },
          boundaryGap: false,
          // interval: 10,
          min: this.xRange.min,
          max: this.xRange.max,
          splitNumber: 7,
          axisLabel: {
            // interval: function(index, value) {
            //   return value % 1 === 0 ? true : false; // 仅在整数刻度处显示
            // },
            interval: 9,
            color: "#fff",
            fontSize: 20,
            formatter: function (value, index) {
              return Number(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#445"
            }
          },
          data: timeSeries
        },
        yAxis: {
          name: this.yName,
          nameTextStyle: {
            fontSize: 16
          },
          min: this.yRange.min,
          max: this.yRange.max,
          minorTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 20
          },
          axisLine: {
            lineStyle: {
              color: "white",
              width: 1
            }
          },
          splitLine: {
            lineStyle: {
              color: "#445"
            }
          }
        },
        series: [
          {
            type: "line",
            data: seriesData,
            showSymbol: false,
            boundaryGap: false, // 不留白，从原点开始
            clip: true,
            lineStyle: {
              color: "#66CCCC",
              width: 2
            }
          }
        ]
      };
      // let xFormater = ''
      // if (this.xRange.min === -6) {
      //   xFormater = function (value, index) {
      //     if (index === 0) return 6
      //     else if (index === 1) return 4
      //     else if (index === 2) return 2
      //     else if (index === 3) return 0
      //     else if (index === 4) return 2
      //     else if (index === 5) return 4
      //     else if (index === 6) return 6
      //   }
      //   option.xAxis.interval = this.xRange.interval
      //   option.xAxis.axisLabel.formatter = xFormater
      // }
      var main = this.$refs.trend;
      // console.log(main)
      var myChart = this.$echarts.init(main);
      myChart.setOption(option);
    },
    func(x) {
      x /= 10;
      return Math.sin(x) * Math.cos(x * 2 + 1) * Math.sin(x * 3 + 2) * 50;
    },
    generateData() {
      let data = [];
      for (let i = 0; i <= 200; i += 0.1) {
        data.push([i, this.func(i)]);
      }
      return data;
    }
  },
  watch: {
    trendData(newValue) {
      this.trendData = newValue;
      this.dryTrend();
    }
  },
  mounted() {
    // this.generateData()
    this.dryTrend();
  }
};
</script>
<style lang="less" scoped>
.manualtitle {
  line-height: 40px;
  height: 40px;
  background: #606266;
  text-align: center;
  font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilTrendChart.vue